import React, {Component, Fragment} from 'react';
import {inject, observer} from 'mobx-react';
import {action, observable} from 'mobx';
import SvgIcon from '@material-ui/core/SvgIcon';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import TaskContainer from './task/TaskContainer';
import TimelineContainer from './timeline/TimelineContainer';
import NotesContainer from './notes/NotesContainer';
import VideoContainer from './video/VideoContainer';
import iconTask from '../../../assets/images/studio/task';
import iconNotes from '../../../assets/images/studio/sample';
import iconVideo from '../../../assets/images/video-cam';
import iconAudio from '../../../assets/images/logo-main';
import iconLoops from '../../../assets/images/loop';
import {customEvent} from "../../../utils/analyticsUtil";
import {actions, category, events} from "../../../constants/enums";

const tabClasses = {root: 'm-link', wrapper: 'm-link-wrapper', labelContainer: 'm-label-wrapper', label: 'm-label', selected: 'm-selected'};
const defaultTabIndex = 2;

@inject('projectStore', 'looperStore')
@observer
class StudioMain extends Component {
    @observable activeTabIndex = defaultTabIndex;

    @action setActiveTabIndex = (event, newValue) => {
        if (newValue === 'looper') {
            this.activeTabIndex = defaultTabIndex;
            this.props.looperStore.setShowLooperDrawer(true);
            return;
        }
        this.activeTabIndex = newValue;
        switch (this.activeTabIndex) {
            case 0:
                customEvent(events.CustomEvent, {category: category.Studio, action: actions.ClickTask});
                break;
            case 1:
                customEvent(events.CustomEvent, {category: category.Studio, action: actions.ClickNotation});
                break;
            case 2:
                customEvent(events.CustomEvent, {category: category.Studio, action: actions.ClickAudio});
                break;
            case 3:
                customEvent(events.CustomEvent, {category: category.Studio, action: actions.ClickVideo});
                break;
            default:
        }

    };

    render() {
        const {projectStore, looperStore, isReadOnly} = this.props;
        const isPreview = projectStore.isPreviewProject(looperStore.loopedProject.type);

        return (
            <Fragment>
                <Tabs
                    classes={{root: 'm-studio-navbar', flexContainer: 'm-container', indicator: 'm-indicator'}}
                    variant="fullWidth"
                    value={this.activeTabIndex}
                    onChange={this.setActiveTabIndex}>
                    <Tab
                        disableRipple
                        className="task"
                        classes={tabClasses}
                        icon={<SvgIcon viewBox="0 0 38 38">{iconTask}</SvgIcon>}/>
                    <Tab
                        disableRipple
                        className="notes"
                        classes={tabClasses}
                        icon={<SvgIcon viewBox="0 0 36 36">{iconNotes}</SvgIcon>}/>
                    <Tab
                        disableRipple
                        className="audio"
                        classes={tabClasses}
                        icon={<SvgIcon viewBox="0 0 40 40">{iconAudio}</SvgIcon>}/>
                    <Tab
                        disableRipple
                        className="video"
                        classes={tabClasses}
                        icon={<SvgIcon viewBox="0 0 20 20">{iconVideo}</SvgIcon>}/>
                    <Tab
                        value={'looper'}
                        disableRipple
                        className="loops"
                        classes={tabClasses}
                        icon={<SvgIcon viewBox="0 0 40 40">{iconLoops}</SvgIcon>}/>
                </Tabs>
                <div className="m-studio-main">
                    {this.activeTabIndex === 0 && <TaskContainer previewMode={isPreview} isReadOnly={isReadOnly}/>}
                    {this.activeTabIndex === 1 && <NotesContainer previewMode={isPreview} isReadOnly={isReadOnly}/>}
                    {this.activeTabIndex === 2 && <TimelineContainer />}
                    {this.activeTabIndex === 3 && <VideoContainer previewMode={isPreview} isReadOnly={isReadOnly}/>}
                </div>
            </Fragment>
        );
    }
}

export default StudioMain;
